

import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import { APIResponseGetWarningRequestTypes } from "../../../services/APIEarlyWarningService";
import { FlatAdmin } from "../../createWarningComp/CreateWarningTypes";
import { DownIcon, UpIcon } from "../../iconSet/IconSet";


type WarningData = APIResponseGetWarningRequestTypes;

type WarningTableProps = {
	data: WarningData[];
	onRowClick: (warning: APIResponseGetWarningRequestTypes) => void;
};

const WarningTable: React.FC<WarningTableProps> = ({ data, onRowClick }) => {
	const [numberOfRows, setNumberOfRows] = useState<number>(10);
	const [selectedCodes, setSelectedCodes] = useState<Set<string>>(
		new Set<string>()
	);
	//const [selectedAreas, setSelectedAreas] = useState<Set<string>>(new Set());

	const [selectedArea, setSelectedArea] = useState<string[]>([]);
	const [tableData, setTableData] = useState<FlatAdmin[]>([]);

	const [filterTableData, setFilterTableData] = useState<WarningData[]>([]);
	const [pagination, setPagination] = useState<WarningData[][]>([]);
	const [selectedPagination, setSelectedPagination] = useState<number>(0);

	const sliceCountRef = useRef<HTMLInputElement>(null);
	const searchRef = useRef<HTMLInputElement>(null);

	// true = A -> Z
	// false = Z -> A
	const [warningIdSort, setWarningIdSort] = useState<Boolean>(true)
	const warningIdSortHandle = () => {
		setWarningIdSort(prevState => !prevState)
	}
	useEffect(() => {
		setFilterTableData(prevState => {
			return [...prevState].sort((a, b) => {
				const warningIdComparison = warningIdSort ? a.warningId.localeCompare(b.warningId) : b.warningId.localeCompare(a.warningId)
				return warningIdComparison
			})
		})
	}, [warningIdSort])

	const [titleSort, setTitleSort] = useState<Boolean>(true)
	const titleSortHandle = () => {
		setTitleSort(prevState => !prevState)
	}
	useEffect(() => {
		setFilterTableData(prevState => {
			return [...prevState].sort((a, b) => {
				const titleComparison = titleSort ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title)
				return titleComparison
			})
		})
	}, [titleSort])

//   useEffect(() => {
//   if (props.areas && props.areas.length > 0) {
//     const incomingSet = new Set(props.areas);
//     const areEqual =
//       props.areas.length === selectedCodes.size &&
//       props.areas.every((code) => selectedCodes.has(code));

//     if (!areEqual) {
//       setSelectedCodes(incomingSet);
//     }
//   }
// }, [props.areas]);

	const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			setSelectedArea((prevState) => [...prevState, event.target.name]);
		} else {
			setSelectedArea((prevState) =>
				prevState.filter((item) => item !== event.target.name)
			);
		}
	};

	// Selected country
	const country = process.env.REACT_APP_COUNTRY;


	useEffect(() => {
		setFilterTableData(data);
	}, [data]);

	useEffect(() => {
		const pages: WarningData[][] = [];
		for (let i = 0; i < filterTableData.length; i += numberOfRows) {
			pages.push(filterTableData.slice(i, i + numberOfRows));
		}
		setPagination(pages);
		setSelectedPagination(0); // Reset page
	}, [filterTableData, numberOfRows]);


	const handleSliceCountChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = Number(e.target.value);
		if (value > 0) setNumberOfRows(value);
	};

	const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value.toLowerCase();
		if (value === "") {
			setFilterTableData(data);
		} else {
			setFilterTableData(
				data.filter((item) =>
					item.title.toLowerCase().includes(value) ||
					item.warningId.toLowerCase().includes(value)
				)
			);
		}
	};

	const paginationNavigation = (side: "next" | "prev") => {
		if (side === "next") {
			if (pagination.length > selectedPagination + 1) {
				setSelectedPagination((prevState) => prevState + 1);
				console.log(">>>> good next");
			}
		} else if (side === "prev") {
			if (0 <= selectedPagination - 1) {
				setSelectedPagination((prevState) => prevState - 1);
			}
		}
	};

	useEffect(() => {
		const sortedData = [...data].sort((a, b) => {
			return new Date(b.createAt).getTime() - new Date(a.createAt).getTime(); // Descending
		});

		setFilterTableData(sortedData);
	}, [data]);

	return (
		<div style={{ width: "100%"}} className="warningTable-wrapper" /* style={{ maxWidth: 500, margin: "auto", fontFamily: "Arial, sans-serif" }} */>
			{/* <span className="main-title">Warnings Table</span> */}

			<div className="field-wrapper">
				<div className="left">
					<span>
						show
						<input
							type="number"
							ref={sliceCountRef}
							defaultValue={numberOfRows}
							min={1}
							onChange={handleSliceCountChange}
						/>
						Entries
					</span>
				</div>
				<div className="right">
					<span>
						search
						<input
							type="text"
							ref={searchRef}
							onChange={handleSearch}
							placeholder="Search here"
						/>
					</span>
				</div>
			</div>
			<div className="table-wrapper">
				<div className="table-row header" style={{ gridTemplateColumns: `15rem auto` }} >
					<span onClick={(e) => warningIdSortHandle()}>
						Warning ID
						<div>
							{warningIdSort ? (
								<UpIcon width="1rem" color="var(--color-main-white)" />
							) : (
								<DownIcon width="1rem" color="var(--color-main-white)" />
							)}
							
						</div>
					</span>
					<span onClick={(e) => titleSortHandle()}>
						Description
						<div>
							{titleSort ? (
								<UpIcon width="1rem" color="var(--color-main-white)" />
							) : (
								<DownIcon width="1rem" color="var(--color-main-white)" />
							)}
							
						</div>
					</span>
				</div>
			</div>
			{pagination[selectedPagination]?.map((warning, index) => (
				<div style={{}} key={index} className="table-wrapper">
					<div
						className="table-row"
						style={{ gridTemplateColumns: `15rem auto` }}
						 onClick={() => onRowClick(warning)} 
					>
						{/* <span style={{ justifyContent: "center" }}>
							<input
								type="checkbox"
								onChange={(e) => handleCheckboxChange(e)}
								checked={selectedCodes.has(warning.warningId)}
								name={warning.warningId}
							/>
						</span> */}
						<span style={{ justifyContent: "left" }}>{warning.warningId}</span>
						<span style={{ justifyContent: "left" }}>{warning.title}</span>
					</div>
				</div>
			))}
			{pagination.length === 0 && (
				<div className="table-no-data-wrapper">
					<span>no any data available</span>
				</div>
			)}
			<div className="table-pagination-wrapper">
				{/* <div
					className="icon-page-box"
					style={{ marginBottom: "0.5rem" }}
					onClick={(e) => paginationNavigation("prev")}
				>
					&lt;
				</div> */}
				<div className="page-wrapper">
					{/* Show previous button if not on first page group */}
					{selectedPagination >= 6 && (
						<span
							className="icon-page-box"
							onClick={() =>
								setSelectedPagination(Math.max(0, selectedPagination - 6))
							}
						>
							&lt;&lt;
						</span>
					)}
					<div
						className="icon-page-box"
						style={{ marginBottom: "0.0rem" }}
						onClick={(e) => paginationNavigation("prev")}
					>
						&lt;
					</div>
					{/* Show current page group (10 pages at a time) */}
					{pagination
						.slice(
							Math.floor(selectedPagination / 6) * 6,
							Math.floor(selectedPagination / 6) * 6 + 6
						)
						.map((_, idx) => {
							const pageNumber = Math.floor(selectedPagination / 6) * 6 + idx;
							return (
								<span
									key={pageNumber}
									className={
										selectedPagination === pageNumber
											? "icon-page-box selected"
											: "icon-page-box"
									}
									onClick={() => setSelectedPagination(pageNumber)}
								>
									{pageNumber + 1}
								</span>
							);
						})}

					<div
						className="icon-page-box"
						style={{ marginBottom: "0.0rem" }}
						onClick={(e) => paginationNavigation("next")}
					>
						&gt;
					</div>

					{/* Show next button if there are more pages */}
					{Math.floor(selectedPagination / 6) * 6 + 6 < pagination.length && (
						<span
							className="icon-page-box"
							onClick={() =>
								setSelectedPagination(
									Math.min(
										pagination.length - 1,
										Math.floor(selectedPagination / 6) * 6 + 6
									)
								)
							}
						>
							&gt;&gt;
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default WarningTable;

